import { FC } from 'react';
import styles from './logo.module.scss';
import { classnames } from '@/utils/functions';

interface LogoProps {
  className?: string;
  label?: string;
}

/**
 * The Gannet logo, painted in the current text color through a CSS mask so a
 * single asset works on light and dark backgrounds. Set `color` on a parent to
 * change it.
 */
const Logo: FC<LogoProps> = ({ className = '', label = 'Gannet' }) => {
  return (
    <span
      role="img"
      aria-label={label}
      className={classnames(styles.logo, className)}
    />
  );
};

export default Logo;
